<template>
	<div class="container" v-if="is_valid_hash">
		<h2>{{ client }}</h2>
		<form id="form" @submit.prevent="submit">
			<form-wizard
				title=""
				subtitle=""
				nextButtonText="Suivant"
				backButtonText="Précédent"
				finishButtonText="Terminer"
				@on-complete="processForm"
				class="form-wizard"
				ref="formwizard"
			>
				<tab-content title="Nom(s) de domaine">
					<p>
						Nous avons besoin de connaitre votre nom de domaine,
						autrement dit l'adresse, de votre site actuel.
					</p>
					<p>Exemple : hotel-exemple.com</p>
					<p
						id="domain-choice"
						v-bind:class="{
							'selection-made': model.has_domain_selection_made,
						}"
					>
						<a
							@click="setHasDomain(false)"
							v-bind:class="{
								'is-selected':
									model.has_domain_selection_made &&
									model.has_domain_name == false,
							}"
							>Je n'ai pas encore de nom de domaine</a
						>

						ou

						<a
							@click="setHasDomain(true)"
							v-bind:class="{
								'is-selected':
									model.has_domain_selection_made &&
									model.has_domain_name == true,
							}"
							>Je déjà un ou des nom(s) de domaine</a
						>
					</p>

					<div v-if="model.has_domain_selection_made">
						<div v-if="!model.has_domain_name">
							<FormulateInput
								v-model="model.has_desired_domain"
								:options="{
									false:
										'Vous souhaitez recevoir des suggestions de nom(s) de domaine',
									true:
										'Vous savez déjà quel nom(s) de domaine vous aimeriez',
								}"
								type="radio"
							/>

							<div v-if="model.has_desired_domain == 'true'">
								<FormulateInput
									type="textarea"
									label="Listez ici les noms de domaine que vous souhaiterez
								réserver (un par ligne)"
									v-model="model.desired_domains"
								/>
							</div>

							<p v-if="model.has_desired_domain == 'true'">
								Nous vérifierons la disponibilité de ces
								domaine(s) et nous vous contacterons pour
								réserver la meilleure option.
							</p>
						</div>

						<div v-if="model.has_domain_name">
							<FormulateInput
								type="text"
								label="Quel est votre nom de domaine actuel ?"
								v-model="model.current_domain"
							/>

							<FormulateInput
								type="textarea"
								label="Avez-vous des noms de domaine secondaires (un par ligne)"
								v-model="model.inputted_secondary_domains"
								@input="processSecondaryDomains"
							/>

							<FormulateInput
								v-model="model.retain_secondary_domains"
								:options="{
									true: 'Oui',
									false: 'Non',
								}"
								label="Souhaitez-vous conserver toutes ces nom de domaines secondaires ? "
								type="radio"
							/>

							<FormulateInput
								v-model="model.secondary_domains_to_remove"
								:options="model.secondary_domains"
								type="checkbox"
								label="Cochez le ou les noms de domaine que vous ne souhaitez pas retenir"
								v-if="model.retain_secondary_domains == 'false'"
							/>

							<FormulateInput
								v-model="model.has_registar_access"
								:options="{
									true:
										'J\'ai un accès direct à la gestion de mes noms de domaine',
									false:
										'Mes noms de domaine sont gérés par une agence',
								}"
								label="Gestion de vos noms de domaine"
								type="radio"
							/>

							<FormulateInput
								type="text"
								label="Quel est le nom de votre registrar ? *"
								help="* Le Registra eet la société auprès de laquelle votre nom de domaine est enregistré. Ex : OVH, Gandi, Nordnet, 1 & 1, IONOS..."
								v-if="model.has_registar_access == 'true'"
								v-model="model.registrar"
							/>

							<FormulateInput
								type="textarea"
								label="Inscrivez ici vos Identifiants/codes d’accès au registrar : Utilisateur et mot de passe "
								v-if="model.has_registar_access == 'true'"
								v-model="model.registrar_connexion"
							/>

							<FormulateInput
								type="text"
								label="Quel est le nom de cette agence ?"
								v-if="model.has_registar_access == 'false'"
								v-model="model.agency"
							/>

							<FormulateInput
								type="textarea"
								label="Inscrivez ici votre contact chez cette agence"
								v-if="model.has_registar_access == 'false'"
								v-model="model.agency_contact"
							/>

							<FormulateInput
								type="checkbox"
								label="Je souhaite changer de nom de domaine principale"
								value="true"
								v-model="model.domain_change_required"
							/>

							<FormulateInput
								type="text"
								label="Indiquez ici le nouveau nom de domaine souhaitez"
								v-if="model.domain_change_required == true"
								v-model="model.domain_change"
							/>

							<FormulateInput
								v-model="model.is_domain_change_purchased"
								:options="{
									true: 'J\'ai déjà acheté ce domaine',
									false:
										'Je souhaite qu\'Otelico l\'enregistre pour moi',
								}"
								v-if="model.domain_change_required == true"
								type="radio"
							/>
						</div>
					</div>
				</tab-content>

				<tab-content title="Hébergement">
					<div v-if="model.has_domain_name">
						<FormulateInput
							v-model="model.is_hosting_company_same"
							:options="{
								true:
									'L\'agence en charge de mes nom(s) de domaine est également celle qui héberge mon site',
								false: 'Une agence différente héberge mon site',
							}"
							label="Mon hébergeur"
							type="radio"
						/>

						<FormulateInput
							type="text"
							label="Quel est le nom de cette agence ?"
							v-if="model.is_hosting_company_same == 'false'"
							v-model="model.hosting_company"
						/>

						<FormulateInput
							type="textarea"
							label="Inscrivez ici votre contact chez cette agence"
							v-if="model.is_hosting_company_same == 'false'"
							v-model="model.hosting_company_contact"
						/>

						<FormulateInput
							v-model="model.has_informed_resiliation"
							:options="{
								true:
									'J\'ai déjà prévenu l\'agence de notre résiliation',
								false:
									'Je n\'ai pas encore prévenu l\'agence que nous changeons de prestataire',
							}"
							label="Résiliation"
							type="radio"
						/>

						<p
							v-if="model.has_informed_resiliation == 'false'"
							id="message-model-email"
						>
							Nous allons vous faire parvenir un email type à
							envoyer à votre agence afin de préparer le transfert
							de vos services chez Otelico.
						</p>

						<FormulateInput
							type="datepicker"
							label="Si vous connaissez la date de fin de service chez votre prestataire actuel, indiquez la ci-dessous"
							v-model="model.date_end_contract"
						/>
					</div>

					<div v-else>
						<p>
							Même si vous n'avez pas de nom de domaine encore, il
							est possible que vous avez déjà un site de type Wix,
							Pages Jaunes ou Pages Perso.
						</p>

						<p>Si oui, merci de nous indiquer l'adresse.</p>

						<FormulateInput
							v-model="model.has_website"
							:options="{
								false: 'Je n\'ai pas de site',
								true: 'J\'ai déja un site',
							}"
							label="Mon site internet existant"
							type="radio"
						/>

						<FormulateInput
							type="text"
							label="Quelle est l'adresse de votre site ?"
							v-if="model.has_website == 'true'"
							v-model="model.existing_website_address"
						/>
					</div>
				</tab-content>

				<tab-content title="Emails">
					<FormulateInput
						type="textarea"
						label="Inscrivez ici les adresses emails que vous utilisez (une par ligne)"
						v-model="model.inputted_emails"
						@input="processEmails"
					/>

					<FormulateInput
						v-model="model.retain_all_emails"
						:options="{
							true: 'Oui',
							false: 'Non',
						}"
						label="Souhaitez conserver toutes ces adresses ?"
						type="radio"
					/>

					<FormulateInput
						v-model="model.emails_to_remove"
						:options="model.current_emails"
						type="checkbox"
						label="Choisir les adresse que vous ne souhaitez plus utiliser"
						v-if="model.retain_all_emails == 'false'"
					/>

					<FormulateInput
						type="checkbox"
						label="Je souhaite créer de nouvelles adresses"
						value="true"
						v-model="model.create_emails_required"
					/>

					<FormulateInput
						type="textarea"
						label="Inscrivez ici les adresses emails que vous souhaitez créer (une par ligne)"
						@input="processEmailsToCreate"
						v-if="model.create_emails_required == true"
					/>

					<FormulateInput
						v-model="model.email_client"
						:options="[
							'Outlook',
							'Exchange',
							'Thunderbird',
							'Gmail',
							'Directement sur le serveur (Gandi, OVH, Orange, SFR ...)',
							'Autre',
						]"
						type="select"
						placeholder="Séléctionner un option"
						label="Avec quel outil consultez-vous vos emails ?"
					/>

					<FormulateInput
						type="textarea"
						label="Inscrivez ici le moyen que vous utiliser pour lire vos emails"
						v-model="model.other_email_client"
						v-if="model.email_client == 'Autre'"
					/>

					<FormulateInput
						v-model="model.email_configuration"
						:options="['En POP', 'En IMAP', 'Je ne sais pas']"
						type="select"
						placeholder="Séléctionner un option"
						label="Savez-vous comment vos comptes email sont configurés ?"
					/>

					<FormulateInput
						v-model="model.has_technical_contact"
						:options="{
							true: 'Oui',
							false: 'Non',
						}"
						label="Avez-vous un informaticien habituel qui gère vos ordinateurs et réseaux ?"
						type="radio"
					/>

					<FormulateInput
						type="textarea"
						label="Inscrivez ici le nom de la société et la personne à contacter"
						v-model="model.technical_contact"
						v-if="model.has_technical_contact == 'true'"
					/>
				</tab-content>

				<tab-content title="Google">
					<FormulateInput
						v-model="model.has_google_analytics"
						:options="{
							true: 'Oui',
							false: 'Non',
							unknown: 'Je ne sais pas',
						}"
						label="Avez-vous déjà un accès à des statistiques Google Analytics ?"
						type="radio"
					/>

					<FormulateInput
						type="textarea"
						label="Indiquez ici les identifiants pour accéder au compte Google Analytics"
						placeholder="Utilisateur, Mot de passe"
						v-model="model.google_analytics_account"
						v-if="model.has_google_analytics == 'true'"
					/>

					<FormulateInput
						v-model="model.has_google_my_business"
						:options="{
							true: 'Oui',
							false: 'Non',
							unknown: 'Je ne sais pas',
						}"
						label="Avez-vous déjà la main sur votre Fiche Google My Business ?"
						type="radio"
					/>

					<FormulateInput
						type="textarea"
						label="Indiquez ici les identifiants pour accéder au compte Google My Business"
						placeholder="Utilisateur, Mot de passe"
						v-model="model.google_my_business_account"
						v-if="model.has_google_my_business == 'true'"
					/>
				</tab-content>
			</form-wizard>
		</form>

		<div v-if="is_processing_form" id="processing-form">Chargement</div>

		<transition
			enter-active-class="animate__animated animate__fadeInDown animate__faster"
			leave-active-class="animate__animated animate__fadeOutUp"
		>
			<div v-if="is_completed" id="completed">
				<div
					class="swal2-icon swal2-success swal2-animate-success-icon"
					style="display: flex"
				>
					<div
						class="swal2-success-circular-line-left"
						style="background-color: rgb(255, 255, 255)"
					></div>
					<span class="swal2-success-line-tip"></span>
					<span class="swal2-success-line-long"></span>
					<div class="swal2-success-ring"></div>
					<div
						class="swal2-success-fix"
						style="background-color: rgb(255, 255, 255)"
					></div>
					<div
						class="swal2-success-circular-line-right"
						style="background-color: rgb(255, 255, 255)"
					></div>
				</div>
				<h2>Merci, vous avez completé votre questionnaire !</h2>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: "Form",
	data: function () {
		return {
			hash: false,
			is_valid_hash: false,
			client: false,
			is_completed: false,
			is_processing_form: false,
			model: {
				has_domain_selection_made: false,
				has_domain_name: false,
				has_desired_domain: "",
				desired_domains: "",
				current_domain: "",
				inputted_secondary_domains: "",
				secondary_domains: "",
				retain_secondary_domains: "",
				secondary_domains_to_remove: "",
				has_registar_access: "",
				registrar: "",
				agency: "",
				agency_contact: "",
				domain_change_required: "",
				domain_change: "",
				is_domain_change_purchased: "",
				is_hosting_company_same: "",
				hosting_company: "",
				hosting_company_contact: "",
				has_website: "",
				existing_website_address: "",
				has_informed_resiliation: "",
				date_end_contract: "",
				current_emails: [],
				retain_all_emails: "",
				emails_to_remove: "",
				create_emails_required: "",
				emails_to_create: [],
				email_client: "",
				other_email_client: "",
				email_configuration: "",
				has_technical_contact: "",
				has_google_analytics: "",
				google_analytics_account: "",
				has_google_my_business: "",
				google_my_business_account: "",
			},
			timeout: null,
		};
	},

	beforeCreate() {
		let hash = this.$route.query.hash;

		fetch(
			process.env.VUE_APP_API_URL +
				"/domain-name-questionnaires/checkHash.json?hash=" +
				hash
		)
			.then((response) => response.json())
			.then((data) => {
				if (data.status == "success") {
					this.is_valid_hash = true;

					if (data.client) {
						this.client = data.client;
					}
					this.hash = hash;
				}
			});
	},
	methods: {
		processForm() {
			this.is_processing_form = true;

			fetch(
				process.env.VUE_APP_API_URL +
					"/domain-name-questionnaires/save.json?hash=" +
					this.hash,
				{
					method: "post",
					body: JSON.stringify(this.model),
					headers: {
						"Content-type": "application/json; charset=UTF-8",
					},
				}
			)
				.then((response) => response.json())
				.then((data) => {
					this.is_processing_form = false;

					if (data.status == "success") {
						this.is_completed = true;
					}
				})
				.catch((error) => {
					this.is_processing_form = false;
				});
		},
		setHasDomain(value) {
			this.model.has_domain_selection_made = true;
			this.model.has_domain_name = value;
		},
		processSecondaryDomains(value) {
			clearTimeout(this.timeout);

			this.timeout = setTimeout(() => {
				this.model.secondary_domains = value
					.split("\n")
					.filter(Boolean);
			}, 500);
		},
		processEmails(value) {
			clearTimeout(this.timeout);

			this.timeout = setTimeout(() => {
				this.model.current_emails = value.split("\n").filter(Boolean);
			}, 500);
		},
		processEmailsToCreate(value) {
			clearTimeout(this.timeout);

			this.timeout = setTimeout(() => {
				this.model.emails_to_create = value.split("\n").filter(Boolean);
			}, 500);
		},
	},
};
</script>

<style lang="scss">
.formulate-input {
	.formulate-input-element {
		max-width: none !important;
	}

	.formulate-input-label {
		&--before {
			font-size: 1rem !important;
			color: #4a646e;
		}
	}
}

.wizard-tab-container {
	max-width: 600px;
	margin: auto;
}

h2 {
	text-align: center;
}

#domain-choice {
	margin: 1rem 0;
	display: flex;
	justify-content: center;
	align-items: center;
	font-style: italic;
	a {
		margin: 1rem;
		padding: 1rem 2rem;
		cursor: pointer;
		color: #fff;
		display: block;
		text-align: center;
		font-size: 1.2rem;
		font-style: normal;
		transition: all 0.2s ease-out;
		border-radius: 5px;

		&:first-child {
			background-color: #ed9834;
			margin-left: 0;
		}

		&:last-child {
			background-color: #4a646e;
			margin-right: 0;
		}
	}

	&.selection-made {
		a {
			opacity: 0.2;
		}
		.is-selected {
			background-color: #94c950;
			opacity: 1;
		}
	}
}

#message-model-email {
	padding: 0.5rem;
	background: #ed9834;
	border: 1px solid #b36c1b;
	color: #fff;
}
.vue-form-wizard .wizard-card-footer {
	display: flex;
	justify-content: center;

	.wizard-btn {
		margin: 0 1rem;
	}
}

#completed {
	position: fixed;
	background-color: #fff;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
</style>